const gtmStandardVariables = {
  event: undefined,
  // eslint-disable-next-line camelcase
  event_category: undefined,
  // eslint-disable-next-line camelcase
  event_label: undefined,
  // eslint-disable-next-line camelcase
  event_value: undefined,
};

export const gtm = (event, callback) => {
  if (typeof window !== 'undefined') {
    // Create the `window.dataLayer` array if GTM isn't loaded yet, so we
    // don't lose any events.
    // https://www.simoahava.com/gtm-tips/datalayer-declaration-vs-push/
    // https://developers.google.com/tag-manager/devguide#adding-data-layer-variables-to-a-page
    if (!window.dataLayer) {
      window.dataLayer = [];
    }

    return window.dataLayer.push(
      {
        // We need to flush Standard Variable otherwise they can leak
        // from one push to the next one
        // see https://www.simoahava.com/gtm-tips/remember-to-flush-unused-data-layer-variables/
        ...gtmStandardVariables,
        ...event,
      },
      callback
    );
  }
};
